<template>
  <div>
    <div class="brands-operations">
      <div>
        <a-button v-if="$hasPermissions(['rcs:brand:create'])" type="primary" class="add-btn" @click="jumpToCreator()"
          >新增</a-button
        >
      </div>
      <div class="data-filter" v-if="filterOptions">
        <a-select
          v-if="filterSelected"
          :default-value="filterSelected.value"
          style="width: 120px"
          @change="hangleChange"
        >
          <a-icon slot="suffixIcon" type="down" />
          <a-select-option v-for="provider in filterOptions" :key="provider.value" :value="provider.value">{{
            provider.label
          }}</a-select-option>
        </a-select>
        <a-input
          v-model="searchKeyword"
          class="search-keyword"
          clearable
          placeholder
          @keyup.enter.native="doSearch"
        ></a-input>
        <a-button class="search-btn" type="primary" @click="doSearch()">搜索</a-button>
      </div>
    </div>
    <a-table
      :pagination="false"
      :columns="this.$constRepository.brand.columns"
      :data-source="brandList"
      class="brands-table"
      rowKey="brandId"
    >
      <span slot="customTitle"> <a-icon type="smile-o" />Name </span>
      <span slot="tags" slot-scope="tags">
        <a-tag
          v-for="tag in tags"
          :key="tag"
          :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
          >{{ tag.toUpperCase() }}</a-tag
        >
      </span>
      <span slot="action" slot-scope="scope">
        <a-button v-if="$hasPermissions(['rcs:brand:update'])" class="green-btn" ghost @click="jumptoEdit(scope)"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-button v-if="$hasPermissions(['rcs:i18n:list'])" class="green-btn" ghost @click="jumptoI18n(scope)"
          >国际化</a-button
        >
        <a-divider type="vertical" />
        <a-button v-if="$hasPermissions(['rcs:brand:delete'])" class="red-btn" ghost>
          <a-popconfirm okText="是" cancelText="否" title="是否删除品牌?" @confirm="() => onDelete(scope)">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </a-button>
      </span>
    </a-table>
    <div class="pagination">
      <a-pagination
        :current="pageInfo.page"
        :show-total="(total) => `共 ${pageInfo.totalElements} 条`"
        show-quick-jumper
        show-size-changer
        :total="pageInfo.totalElements"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
        :pageSizeOptions="['10', '20', '30', '40']"
      />
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandList',
  components: {},
  activated() {
    this.loadedPageData();
  },
  data() {
    return {
      filterSelected: this.$constRepository.brand.FILTER_OPTION_BRAND_NAME,
      filterOptions: [
        this.$constRepository.brand.FILTER_OPTION_BRAND_NAME,
        this.$constRepository.brand.FILTER_OPTION_BRAND_ENNAME,
      ],
      brandList: undefined,
      searchKeyword: '',
      requestParams: {},
      pageInfo: {
        page: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    hangleChange(value) {
      this.filterOptions.forEach((brand) => {
        if (brand.value === value) {
          this.filterSelected = brand;
        }
      });
    },
    processSearchKeyword() {
      this.$set(this.requestParams, 'name', undefined);
      this.$set(this.requestParams, 'enName', undefined);
      switch (this.filterSelected) {
        case this.$constRepository.brand.FILTER_OPTION_BRAND_NAME:
          this.$set(this.requestParams, 'name', this.searchKeyword);
          break;
        case this.$constRepository.brand.FILTER_OPTION_BRAND_ENNAME:
          this.$set(this.requestParams, 'enName', this.searchKeyword);
          break;
        default:
          break;
      }
    },
    doSearch() {
      this.pageInfo.page = 1;
      this.loadedPageData();
    },
    async loadedPageData() {
      this.processSearchKeyword();
      await this.listBrand(this.requestParams.name, this.requestParams.enName, this.pageInfo);
      if (this.pageInfo.currentPage + 1 > this.pageInfo.totalPages && this.pageInfo.currentPage) {
        await this.listBrand(this.requestParams.name, this.requestParams.enName, this.pageInfo);
      }
    },
    async listBrand(Name, enName, queryPage) {
      const params = {
        name: Name,
        enName,
        page: queryPage.page - 1,
        size: queryPage.size,
      };
      const response = await this.$apiManager.brand.getBrands(params);
      this.brandList = response.data.elements;
      this.$set(this.pageInfo, 'totalElements', response.data.totalElements);
      this.$set(this.pageInfo, 'totalPages', response.data.totalPages);
      this.$set(this.pageInfo, 'currentPage', response.data.currentPage);
    },
    async onDelete(brand) {
      await this.$apiManager.brand.deleteBrands(brand.brandId);
      if (this.brandList.length === 1 && this.pageInfo.page !== 1) {
        this.pageInfo.page -= 1;
      }
      this.loadedPageData();
    },
    jumptoEdit(info) {
      this.$router.push({ name: 'brandEdit', params: { brand: info } });
    },
    jumptoI18n(info) {
      this.$router.push({ name: 'brandI18n', params: { brand: info } });
    },
    jumpToCreator() {
      this.$router.push({ name: 'brandCreator' });
    },
    onShowSizeChange(current, pageSize) {
      this.pageInfo.page = 1;
      this.$set(this.pageInfo, 'size', pageSize);
      this.loadedPageData();
    },
    onChange(pageNumber) {
      this.$set(this.pageInfo, 'page', pageNumber);
      this.loadedPageData();
    },
  },
};
</script>

<style lang="less" scoped>
.green-btn {
  color: green;
  border: none;
}
.red-btn {
  color: red;
  border: none;
}
.brands-operations {
  display: flex;
  justify-content: space-between;
  .add-btn {
    // margin: 10px 0px;
    margin-left: 3%;
  }
  .data-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    .tip {
      color: #4c4c4c;
    }
    .date-picker-style {
      margin: 0 10px;
    }
    .search-options {
      width: 100px;
    }
    .search-keyword {
      width: 200px;
    }
    .search-btn {
      // margin: 10px 0px;
      margin-left: 3%;
    }
  }

}
.brands-table {
    margin-top: 1%;
  }
.pagination {
  margin-top: 3%;
}
</style>
